Vue.component("vue-flatpickr", {
  template: '<input type="text" :placeholder="placeholder" :value="value" @input="onInput" />',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function(){return{};}
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      fp: null
    }
  },
  computed: {
    fpOptions: function () {
      return JSON.stringify(this.options)
    }
  },
  watch: {
    fpOptions: function (newOpt) {
      var option = JSON.parse(newOpt)
      for (var o in option) {
        this.fp.set(o, option[o])
      }
    }
  },
  mounted: function () {
    var self = this
    var origOnValUpdate = this.options.onValueUpdate
    this.fp = new Flatpickr(this.$el, Object.assign(this.options, {
      onValueUpdate: function () {
        self.onInput(self.$el.value)
        if (typeof origOnValUpdate === 'function') {
          origOnValUpdate()
        }
      }
    }))
    this.$emit('FlatpickrRef', this.fp)
  },
  destroyed: function () {
    this.fp = null
  },
  methods: {
    onInput: function (e) {
      typeof e === 'string' ? this.$emit('input', e) : this.$emit('input', e.target.value)
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./public_html/scripts/vue-components/_flatpickr.js
// module id = 8
// module chunks = 0